import FormLabel from '@mui/material/FormLabel';
import { saveAs } from 'file-saver';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DownloadIcon from '@mui/icons-material/Download';

export default function BackupAccount({
  keys,
  username,
  newNotification,
  setIsDownloaded,
}) {
  const accountDetailsBackup =
    `--------------- YOUR HIVE ACCOUNT -------------\n` +
    `Username: ${username}\n` +
    `Passphrase: ${keys.password}\n\n` +
    `------------------------ PRIVATE KEYS ----------------------\n` +
    `Owner:   ${keys.privateKeys.owner}\n` +
    `Active:  ${keys.privateKeys.active}\n` +
    `Posting: ${keys.privateKeys.posting}\n` +
    `Memo:    ${keys.privateKeys.memo}\n\n` +
    `-------------------------- KEY DESCRIPTION -----------------------\n` +
    `Owner:   Change Passphrase, Change Keys, Recover Account\n` +
    `Active:  Transfer Funds, Power up/down, Voting Witnesses/Proposals\n` +
    `Posting: Post, Comment, Vote, Reblog, Follow, Profile\n` +
    `Memo:    Send/View encrypted messages on transfers\n\n` +
    `---------------------- WHERE TO USE YOUR KEYS --------------------\n` +
    `Hive Keychain and Hivesigner should allow you to do transactions\n` +
    `on all Hive sites and applications.\n\n` +
    `Be very careful directly using your keys on any other website or application.`;

  const downloadBackupFile = () => {
    var blob = new Blob([accountDetailsBackup], {
      type: 'text/plain;charset=utf-8',
    });
    saveAs(blob, 'HIVE-ACOUNT-' + username + '-BACKUP.txt');
    setIsDownloaded(true);
  };

  return (
    <>
      <FormLabel component="legend">
        This is your proposed account information. It is crucial to keep it
        private and secure. After you save this information, your account will
        be created. You will need these details to access your rewards and use
        other Hive apps.
      </FormLabel>
      <CopyToClipboard
        text={accountDetailsBackup}
        onCopy={() =>
          newNotification({
            success: true,
            message:
              'Your keys have been copied to your clipboard. Keep them private and secure.',
          })
        }
      >
        <div className="tw-bg-primary-100 dark:tw-bg-primary-900 tw-p-2 tw-rounded tw-m-2">
          <Typography>
            <b>Username: {username}</b>
          </Typography>
          <Typography>
            <b>Passphrase: {keys.password}</b>
            <br /> <br />
          </Typography>
          <Typography>
            <b>------------------------ PRIVATE KEYS ----------------------</b>
          </Typography>
          <Typography>
            <b>
              Owner:&nbsp;&nbsp;&nbsp;
              {keys.privateKeys.owner}
            </b>
          </Typography>
          <Typography>
            <b>
              Active:&nbsp;&nbsp;
              {keys.privateKeys.active}
            </b>
          </Typography>
          <Typography>
            <b>Posting: {keys.privateKeys.posting}</b>
          </Typography>
          <Typography>
            <b>
              Memo:&nbsp;&nbsp;&nbsp;&nbsp;
              {keys.privateKeys.memo}
            </b>
          </Typography>
        </div>
      </CopyToClipboard>
      <Button
        variant="contained"
        color="primary"
        onClick={downloadBackupFile}
        className="ml-2"
      >
        <DownloadIcon />
        <span className="tw-pl-2">Download keys</span>
      </Button>
      <div className="tw-bg-red-100 dark:tw-bg-red-900 tw-p-4 tw-pb-2 tw-rounded tw-mt-2 tw-border-dotted tw-border-2 tw-border-red-500">
        <FormLabel component="legend">
          <strong>Important: </strong> In a decentralized social network, there
          is <strong>no option to reset your password</strong>. If you lose your
          passphrase and your private keys, you will lose access to your account
          and your accumulated rewards. To prevent this,{' '}
          <strong>download your keys and store them safely.</strong> We also
          recommend writing down your passphrase on a piece of paper and keeping
          it in a secure place.
        </FormLabel>
      </div>
    </>
  );
}
